import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACK = [
  { quote: "Saans gave me exclusive rights for my district and the marketing kit made selling to doctors effortless. My monthly orders have tripled.",
    name: "Rajesh Kumar", role: "PCD Partner · Uttar Pradesh",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=300" },
  { quote: "Consistent quality, on-time dispatch and transparent pricing. As a distributor, that reliability is everything.",
    name: "Anita Deshpande", role: "Distributor · Maharashtra",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=300" },
  { quote: "The formulations are genuinely well-made. I recommend their Chyawanprash and juices to patients with confidence.",
    name: "Dr. S. Menon", role: "Ayurvedic Physician · Kerala",
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?crop=entropy&cs=srgb&fm=jpg&q=85&w=300" },
];

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials")
      .then(({ data }) => setItems((data.testimonials && data.testimonials.length) ? data.testimonials : FALLBACK))
      .catch(() => setItems(FALLBACK));
  }, []);
  const list = items.length ? items : FALLBACK;

  return (
    <section className="bg-[#202124] py-20 md:py-28" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="eyebrow text-[#e79a5b]">Partner Voices</div>
          <h2 className="mt-3 font-serif text-4xl tracking-tight text-white md:text-5xl">
            Trusted by partners across India
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {list.map((t, i) => (
            <motion.figure key={t.id || t.name}
              initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col rounded-2xl bg-[#2b2c2f] p-7" data-testid={`testimonial-${i}`}>
              <Quote size={28} className="text-[#d46a1d]" />
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-[#e6e4df]">"{t.quote}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                {t.image && <img src={t.image} alt={t.name} className="h-11 w-11 rounded-full object-cover" loading="lazy" decoding="async" />}
                <div>
                  <div className="text-sm font-semibold text-white">{t.name}</div>
                  <div className="text-xs text-[#a8a6a0]">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
